/**
 * The four seats, spelled out.
 *
 * Its own module rather than an export beside a component: two surfaces word the same declarer
 * label — the table's controls strip and, on phones, the frame's compact info row — and a
 * constant exported from a `.tsx` file costs that file its fast refresh.
 */
export const DIRECTION_FULL_NAMES: Record<string, string> = {
  N: 'North',
  E: 'East',
  S: 'South',
  W: 'West',
};
